/**
 * Inflomatrix 시스템 내 사용자 Role 상수 (U-04)
 * 6개 사용자 계층 — authMiddleware / JWT / API 권한 매핑 기준
 */
export const ROLES = {
  OWNER: 'owner',
  OPERATIONS_MANAGER: 'operations_manager',
  HR_ADMIN: 'hr_admin',
  ACCOUNTING: 'accounting',
  SALES: 'sales',
  EXTERNAL: 'external',
} as const;

export type UserRole = (typeof ROLES)[keyof typeof ROLES];

export const ROLE_LEVEL: Record<UserRole, number> = {
  owner: 100,
  operations_manager: 80,
  hr_admin: 60,
  accounting: 60,
  sales: 40,
  external: 10,
};

export const ADMIN_ROLES: UserRole[] = [
  ROLES.OWNER,
  ROLES.OPERATIONS_MANAGER,
  ROLES.HR_ADMIN,
  ROLES.ACCOUNTING,
];

const USER_ROLE_SET = new Set<string>(Object.values(ROLES));

export function isUserRole(value: unknown): value is UserRole {
  return typeof value === 'string' && USER_ROLE_SET.has(value);
}

export function normalizeUserRole(value: unknown, fallback: UserRole = ROLES.EXTERNAL): UserRole {
  return isUserRole(value) ? value : fallback;
}
